import { createAction } from 'redux-actions';

export const requestGetSymphonyListAction = createAction('REQUEST/GET_SYMPHONY_LIST');
export const requestUpdateColumnsAction = createAction('REQUEST/SET_SYMPHONY_COLUMNS');
export const requestGetSymphonyStatsAction = createAction('REQUEST/SET_SYMPHONY_STATS');
export const requestGetSymphonyPreferencesAction = createAction('REQUEST/GET_SYMPHONY_PREFERENCES');
export const requestUpdateSymphonyPreferencesAction = createAction(
  'REQUEST/UPDATE_SYMPHONY_PREFERENCES',
);
export const requestUpdateSymphonySearchAction = createAction('REQUEST/UPDATE_SYMPHONY_SEARCH');
export const requestResetSymphonySearchAction = createAction('REQUEST/RESET_SYMPHONY_SEARCH');
